module.exports = {
  fallback: 'Solve the captcha challenge.',
};
